import { render, staticRenderFns } from "./CandidateLoginForm.vue?vue&type=template&id=2a3b5d66&scoped=true&"
import script from "./CandidateLoginForm.vue?vue&type=script&lang=js&"
export * from "./CandidateLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3b5d66",
  null
  
)

export default component.exports